/* Function animation:
 *   call given function for every animation frame while it returns true.
**/
export default function animation(func) {
  const animate = () => {
    if(func())
      window.requestAnimationFrame(animate)
  }
  window.requestAnimationFrame(animate)
}



// WEBPACK FOOTER //
// ./src/float/vue/utils/animation.js